import { render } from "./MyHubsView.vue?vue&type=template&id=08231c18&scoped=true"
import script from "./MyHubsView.vue?vue&type=script&lang=js"
export * from "./MyHubsView.vue?vue&type=script&lang=js"

import "./MyHubsView.vue?vue&type=style&index=0&id=08231c18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08231c18"]])

export default __exports__